import {
    createAccountPage,
    customerServicePages,
    logInPage,
    orderConfirmationPage,
    productDetailPage,
    shoppingBagPage,
} from "@lib/constants/pagePaths";

export type DefaultLayoutConfig = {
    isBackToTopVisible: boolean;
    isCountdownTimerVisible: boolean;
    hasSubtleBackground: boolean;
};

const defaultLayoutConfig: DefaultLayoutConfig = {
    isBackToTopVisible: true,
    isCountdownTimerVisible: true,
    hasSubtleBackground: false,
};

// Custom configurations for specific routes can be added here.
export const getDefaultLayoutConfig = (pathname: string): DefaultLayoutConfig => {
    const shoppingBagPath = shoppingBagPage.en;
    const productPath = productDetailPage.en;
    const orderConfirmationPath = orderConfirmationPage.en;
    const customerServicePath = customerServicePages.en;
    const logInPath = logInPage.en;
    const createAccountPath = createAccountPage.en;

    if (pathname === shoppingBagPath) {
        return {
            ...defaultLayoutConfig,
            isBackToTopVisible: false,
            hasSubtleBackground: true,
        };
    }

    if (pathname.startsWith(productPath)) {
        return {
            ...defaultLayoutConfig,
            isBackToTopVisible: false,
            isCountdownTimerVisible: false,
        };
    }

    if (pathname.startsWith(orderConfirmationPath)) {
        return { ...defaultLayoutConfig, isCountdownTimerVisible: false };
    }

    if (
        pathname === logInPath ||
        pathname.startsWith(createAccountPath) ||
        pathname.startsWith(customerServicePath)
    ) {
        return { ...defaultLayoutConfig, hasSubtleBackground: true };
    }

    return defaultLayoutConfig;
};
